import "./style/index.scss";
import dayjs from "dayjs";
import * as Icon from "@ant-design/icons";
import { Button, Col, Form, Row, DatePicker, Select, DatePickerProps, Image, Modal, Input, Tooltip, Popover, Flex } from "antd";
import { ColumnsType } from "antd/es/table";
import { LancamentoConsignatarioModel } from "../../models/lancamentoConsignatario/lancamentoConsignatarioModel";
import { currencyBRL } from "../../util/dinheiroBRAuxiliar";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { useEffect, useState } from "react";
import { setIdEmpresaPermissao, setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarConsignatario } from "../../services/consiganatarioService";
import {
  setBuscaLancamentoConsignatario,
  setEntityLancamentoConsignatario,
  setModalCadastrarLancamentoConsignatario,
  setModalDeletarLancamentoConsignatario,
  setModalVisualizarReciboConsignatario,
} from "../../redux/slices/lancamentoConsignatario/lancamentoConsignatarioSlice";
import { setBuscaConsignatario, setEntityConsignatario } from "../../redux/slices/consignatario/consignatarioSlice";
import PagamentoAvulsoConsignatario from "./modals/pagamentoAvulso";
import { listarLancamentoConsignatario, removerLancamentoConsignatario } from "../../services/lancamentoConsignatarioService";
import { buscarEmpresa } from "../../services/empresaService";
import { BuscarLancamentoConsignatarioModel } from "../../models/lancamentoConsignatario/buscarLancamentoConsignatarioModel";
import { SaldoConsignatarioModel } from "../../models/lancamentoConsignatario/saldoConsignatarioModel";
import { FilePdf } from "phosphor-react";
import ModalVisualizarReciboConsignatario from "./modals/recibo";
import { buscarSaldoInicioFimConsignatario, listarSaldoConsignatario } from "../../services/prestacaoContaService";
import { setBuscaPrestacaoConta, setEntityPrestacaoConta } from "../../redux/slices/prestacaoConta/prestacaoContaSlice";
import MensagemModal from "../../components/modal/mensagem";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import TableComponent from "../../components/table/tableComponent";
import { BuscarSaldoConsignatarioModel } from "../../models/lancamentoConsignatario/buscarSaldoConsignatarioModel";
import { BuscaConsignatarioModel } from "../../models/consignatario/chamadas/buscaConsignatarioModel";
import { SelectedRowKeysModel } from "../../models/sistema/selectedRowKeysModel";

dayjs.locale("pt-br");

const LancamentoConsignatario = () => {
  //estados globais
  const persistedState = useAppSelector((state) => state.persisted);
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const lancamentoConsignatarioState = useAppSelector((state) => state.lancamentoConsignatario);
  const empresaState = useAppSelector((state) => state.empresa);
  const prestacaoContaState = useAppSelector((state) => state.prestacaoConta);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [saldoAnterior, setSaldoAnterior] = useState<number>(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<SelectedRowKeysModel>({ keys: [], rows: [] } as SelectedRowKeysModel);

  const editar = Object.values(lancamentoConsignatarioState.entity).length !== 0;

  const fetchConsignatario = async (busca: BuscarLancamentoConsignatarioModel) => {
    const retornoConsignatario = await dispatch(
      buscarConsignatario({
        id: persistedState.user.idConsignatario,
        idUsuario: null,
        idEmpresa: persistedState.user.empresa && persistedState.user.empresa.idEmpresa,
        pesquisar: null,
        ativo: null,
      })
    );

    const retornoSaldo = await dispatch(
      buscarSaldoInicioFimConsignatario({
        idConsignatario: busca.idConsignatario,
        data: busca.dataInicio,
      })
    );

    form.setFieldsValue({
      saldoAnterior: retornoSaldo.payload.length === 0 ? 0 : retornoSaldo.payload[0].saldoFim,
      nomeConsignatario: retornoConsignatario.payload[0]?.apelido,
    });
  };

  useEffect(() => {
    dispatch(setTitle("CARTEIRA DOS CONSIGNATÁRIOS"));
    dispatch(buscarEmpresa(empresaState.busca));

    var buscaLancamentoConsignatario = { ...lancamentoConsignatarioState.busca };
    var buscaSaldo = { ...prestacaoContaState.busca };

    form.setFieldsValue({ dataInicio: dayjs(buscaLancamentoConsignatario.dataInicio), dataFim: dayjs(buscaLancamentoConsignatario.dataFim) });

    if (persistedState.user.idConsignatario) {
      buscaLancamentoConsignatario.idConsignatario = persistedState.user.idConsignatario;
      buscaSaldo.idConsignatario = persistedState.user.idConsignatario;

      dispatch(setBuscaLancamentoConsignatario(buscaLancamentoConsignatario));
      dispatch(setBuscaPrestacaoConta(buscaSaldo));

      fetchConsignatario(buscaLancamentoConsignatario);

      dispatch(listarLancamentoConsignatario(buscaLancamentoConsignatario));
      dispatch(listarSaldoConsignatario(buscaSaldo));
    } else if (persistedState.user.empresa !== null) {
      buscaSaldo.idEmpresa = persistedState.user.empresa.idEmpresa;
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    } else {
      form.setFieldsValue({ saldoAnterior: 0 });
    }
  }, []);

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    form.resetFields(["idConsignatario"]);

    let busca: BuscarLancamentoConsignatarioModel = { ...lancamentoConsignatarioState.busca, idConsignatario: null };
    let buscaConsignatario: BuscaConsignatarioModel = { ...consignatarioState.busca, idEmpresa: value };
    let buscaSaldo: BuscarSaldoConsignatarioModel = { ...prestacaoContaState.busca, idConsignatario: null, idEmpresa: value };

    dispatch(setBuscaLancamentoConsignatario(busca));
    dispatch(listarLancamentoConsignatario(busca));

    dispatch(setBuscaConsignatario(buscaConsignatario));
    dispatch(buscarConsignatario(buscaConsignatario));

    dispatch(setBuscaPrestacaoConta(buscaSaldo));
    dispatch(listarSaldoConsignatario(buscaSaldo));
  };

  const onChangeConsignatario = async (value: number) => {
    let busca: BuscarLancamentoConsignatarioModel = { ...lancamentoConsignatarioState.busca, idConsignatario: value };
    let buscaSaldo: BuscarSaldoConsignatarioModel = { ...prestacaoContaState.busca, idConsignatario: value };

    dispatch(setBuscaLancamentoConsignatario(busca));
    dispatch(listarLancamentoConsignatario(busca));

    dispatch(setBuscaPrestacaoConta(buscaSaldo));
    dispatch(listarSaldoConsignatario(buscaSaldo));

    const retorno = await dispatch(
      buscarSaldoInicioFimConsignatario({
        idConsignatario: busca.idConsignatario,
        data: busca.dataInicio,
      })
    );

    setSaldoAnterior(retorno.payload.length !== 0 ? retorno.payload[0].saldoFim : 0);
  };

  const onChangeDataInicio = async (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarLancamentoConsignatarioModel = { ...lancamentoConsignatarioState.busca, dataInicio: dayjs(value).toDate() };
    let buscaSaldo: BuscarSaldoConsignatarioModel = { ...prestacaoContaState.busca };

    dispatch(setBuscaLancamentoConsignatario(busca));
    dispatch(listarLancamentoConsignatario(busca));

    dispatch(setBuscaPrestacaoConta(buscaSaldo));
    dispatch(listarSaldoConsignatario(buscaSaldo));

    const retorno = await dispatch(
      buscarSaldoInicioFimConsignatario({
        idConsignatario: busca.idConsignatario,
        data: dateString === "" ? buscaSaldo.dataFim : dayjs(value).toDate(),
      })
    );

    setSaldoAnterior(retorno.payload.length !== 0 ? retorno.payload[0].saldoFim : 0);
  };

  const onChangeDataFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarLancamentoConsignatarioModel = { ...lancamentoConsignatarioState.busca, dataFim: dayjs(value).toDate() };

    if (dayjs(busca.dataInicio, "DD-MM-YYYY").isAfter(dayjs(value, "DD-MM-YYYY"))) {
      busca.dataInicio = dayjs(value).toDate();
      form.setFieldValue("dataInicio", dayjs(value, "DD/MM/YYYY"));
    }

    dispatch(setBuscaLancamentoConsignatario(busca));
    dispatch(listarLancamentoConsignatario(busca));
  };

  const selecionarLinha = async (value: SelectedRowKeysModel) => {
    setSelectedRowKeys(value);
    var consignatario = prestacaoContaState.listSaldo.filter((a: SaldoConsignatarioModel) => a.idConsignatario === value.rows[0].idConsignatario);

    form.setFieldsValue({ nomeConsignatario: consignatario[0].apelido });

    dispatch(setEntityConsignatario(consignatario[0]));

    let buscaLancamentoConsignatario: BuscarLancamentoConsignatarioModel = { ...lancamentoConsignatarioState.busca, idConsignatario: consignatario[0].idConsignatario };

    dispatch(setBuscaLancamentoConsignatario(buscaLancamentoConsignatario));
    dispatch(listarLancamentoConsignatario(buscaLancamentoConsignatario));

    const retorno = await dispatch(
      buscarSaldoInicioFimConsignatario({
        idConsignatario: buscaLancamentoConsignatario.idConsignatario,
        data: buscaLancamentoConsignatario.dataInicio,
      })
    );

    setSaldoAnterior(retorno.payload?.length !== 0 ? retorno.payload[0].saldoInicio : 0);
  };

  const goModalPagamento = (value: SaldoConsignatarioModel) => {
    dispatch(setEntityLancamentoConsignatario({} as LancamentoConsignatarioModel));
    dispatch(setEntityPrestacaoConta(value));
    dispatch(setModalCadastrarLancamentoConsignatario(true));
  };

  const goEditar = (value: LancamentoConsignatarioModel) => {
    dispatch(setEntityLancamentoConsignatario(value));
    dispatch(setModalCadastrarLancamentoConsignatario(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarLancamentoConsignatario(false));
  };

  const goDeletar = (value: LancamentoConsignatarioModel) => {
    dispatch(setEntityLancamentoConsignatario(value));
    dispatch(setModalDeletarLancamentoConsignatario(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarLancamentoConsignatario(false));
  };

  const goVisualizarRecibo = (value: LancamentoConsignatarioModel) => {
    dispatch(setEntityLancamentoConsignatario(value));
    dispatch(setModalVisualizarReciboConsignatario(true));
  };

  const closeModalVisualizar = () => {
    dispatch(setModalVisualizarReciboConsignatario(false));
  };

  const atualizar = () => {
    dispatch(listarLancamentoConsignatario(lancamentoConsignatarioState.busca));
    dispatch(listarSaldoConsignatario(prestacaoContaState.busca));
  };

  const myContent = (caminhoArquivo: string, extensaoArquivo: string, nome: string) => (
    <Flex>
      {extensaoArquivo === "pdf" ? (
        <Flex justify="center" align="center" vertical>
          <div style={{ justifyContent: "center", alignContent: "center" }}>
            <FilePdf size={48} style={{ cursor: "pointer" }} onClick={() => window.open(caminhoArquivo)} />
          </div>
          <div>
            <a href="#" onClick={() => window.open(caminhoArquivo)}>
              {nome}
            </a>
          </div>
        </Flex>
      ) : (
        <Image width={200} style={{ objectFit: "fill" }} src={caminhoArquivo} />
      )}
    </Flex>
  );

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
    {
      type: "divider",
    },
    {
      label: "Visualizar Recibo",
      key: "3",
      icon: <Icon.PrinterOutlined />,
      function: (item: any) => goVisualizarRecibo(item),
    },
  ];

  const columnsSaldo: ColumnsType<SaldoConsignatarioModel> = [
    {
      title: "CONSIGNATÁRIO",
      dataIndex: "apelido",
    },
    {
      title:
        dayjs(prestacaoContaState.busca.dataFim).format("DD/MM/YYYY") === dayjs().format("DD/MM/YYYY")
          ? "SALDO ATUAL"
          : "SALDO EM" + " " + dayjs(prestacaoContaState.busca.dataFim).format("DD/MM/YYYY"),
      dataIndex: "saldo",
      align: "right",
      render: (_, { saldo }) => (saldo < 0 ? <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(saldo)}</p> : <p style={{ color: "#334155", marginBottom: "0px" }}>{currencyBRL(saldo)}</p>),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: () => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (
        <Tooltip title="Adicionar lançamento avulso">
          <Icon.PlusCircleOutlined style={{ fontSize: "150%" }} onClick={() => goModalPagamento(record)} placeholder="Adicionar lançamento avulso" />
        </Tooltip>
      ),
    },
  ];

  const columns: ColumnsType<LancamentoConsignatarioModel> = [
    {
      title: "DATA",
      dataIndex: "data",
      align: "center",
      width: 80,
      render: (_, record) => <>{record.data !== null && dayjs(record.data).format("DD/MM/YYYY")}</>,
    },
    {
      title: "HISTÓRICO",
      dataIndex: "historico",
    },
    {
      title: "#",
      dataIndex: "caminhoArquivo",
      align: "center" as "center",
      render: (_, record) =>
        record.caminhoArquivo !== null &&
        record.extensaoArquivo !== null &&
        record.nomeArquivo !== null && (
          <Popover title="COMPROVANTE" content={myContent(record.caminhoArquivo, record.extensaoArquivo, record.nomeArquivo)}>
            <Icon.PaperClipOutlined style={{ fontSize: "120%" }} />
          </Popover>
        ),
    },
    {
      title: "VALOR TRANSAÇÃO",
      dataIndex: "valorTransacao",
      align: "right",
      render: (_, record) =>
        record.valorTransacao < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.valorTransacao)}</p>
        ) : (
          <p style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(record.valorTransacao)}</p>
        ),
    },
    {
      title: "SALDO",
      dataIndex: "saldo",
      align: "right",
      render: (_, record) =>
        record.saldo < 0 ? <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.saldo)}</p> : <p style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(record.saldo)}</p>,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              {persistedState.user.idConsignatario ? (
                <Form.Item label="Consignatário" name="nomeConsignatario">
                  <Input type="text" disabled />
                </Form.Item>
              ) : (
                <>
                  {persistedState.user.empresa === null && (
                    <Form.Item
                      label="Empresa"
                      name="idEmpresa"
                      rules={[
                        {
                          required: true,
                          message: "Selecione uma empresa",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="labelSearch"
                        loading={empresaState.loading}
                        onChange={onChangeEmpresa}
                        style={{ width: 300 }}
                        options={empresaState.list.map((a: EmpresaModel) => ({
                          value: a.id,
                          key: a.apelido,
                          label: (
                            <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                              <Flex style={{ lineHeight: "0px" }}>
                                {a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}
                              </Flex>
                              {a.apelido}
                            </Flex>
                          ),
                          labelSearch: a.apelido,
                        }))}
                      />
                    </Form.Item>
                  )}
                  <Form.Item label="Consignatário" name="idConsignatario">
                    <Select
                      showSearch
                      style={{ width: 200 }}
                      optionFilterProp="label"
                      loading={consignatarioState.loading}
                      allowClear
                      disabled={prestacaoContaState.busca.idEmpresa === null}
                      onChange={onChangeConsignatario}
                      options={prestacaoContaState.listSaldo.map((a: SaldoConsignatarioModel) => ({
                        value: a.idConsignatario,
                        label: a.apelido,
                      }))}
                    />
                  </Form.Item>
                </>
              )}
              <Form.Item label="De" name="dataInicio">
                <DatePicker placeholder="" onChange={onChangeDataInicio} format="DD/MM/YYYY" style={{ width: 120 }} disabled={prestacaoContaState.busca.idEmpresa === null} />
              </Form.Item>
              <Form.Item label="Até" name="dataFim">
                <DatePicker placeholder="" onChange={onChangeDataFim} format="DD/MM/YYYY" style={{ width: 120 }} disabled={prestacaoContaState.busca.idEmpresa === null} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <Row gutter={12} className="tablesCarteiro">
        <Col span={10}>
          {prestacaoContaState.listSaldo.length === 1 ? (
            <TableComponent columns={columnsSaldo} data={prestacaoContaState.listSaldo} loading={lancamentoConsignatarioState.loading} />
          ) : (
            <TableComponent
              columns={columnsSaldo}
              data={prestacaoContaState.listSaldo}
              loading={lancamentoConsignatarioState.loading}
              selectionType="radio-allowed"
              rowSelection={selecionarLinha}
              tableProps={{
                onRow: (record: SaldoConsignatarioModel) => {
                  return {
                    onClick: () => {
                      selecionarLinha({ keys: [record.id], rows: [record] });
                    },
                  };
                },
                selectedRowKeys: selectedRowKeys.keys,
              }}
            />
          )}
        </Col>
        <Col span={14}>
          <TableComponent
            columns={columns}
            data={lancamentoConsignatarioState.list}
            loading={lancamentoConsignatarioState.loading}
            tableProps={{
              title: () =>
                saldoAnterior < 0 ? (
                  <>
                    Saldo Anterior: <span style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(saldoAnterior)}</span>
                  </>
                ) : (
                  <>
                    Saldo Anterior: <span style={{ color: "#334155", marginBottom: "0px" }}>{currencyBRL(saldoAnterior)}</span>
                  </>
                ),
            }}
          />
        </Col>
      </Row>
      <Modal
        title={editar ? "EDITAR LANÇAMENTO AVULSO" : "NOVO LANÇAMENTO AVULSO"}
        centered
        width={900}
        open={lancamentoConsignatarioState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <PagamentoAvulsoConsignatario />
      </Modal>
      <Modal title={"RECIBO DE PAGAMENTO"} centered width={500} footer={null} destroyOnHidden open={lancamentoConsignatarioState.modalVisualizarReciboConsignatario} onCancel={closeModalVisualizar}>
        <ModalVisualizarReciboConsignatario />
      </Modal>
      <Modal title={"REMOVER LANÇAMENTO"} centered width={350} open={lancamentoConsignatarioState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o lançamento?"
          action={removerLancamentoConsignatario({ value: lancamentoConsignatarioState.entity, busca: lancamentoConsignatarioState.busca })}
          close={setModalDeletarLancamentoConsignatario(false)}
        />
      </Modal>
    </Flex>
  );
};

export default LancamentoConsignatario;
